/*
  Author: Shipla, Prasuk
  Info: JS file for InspectionSummary Component
*/
import {
  Component,
  Prop,
  Vue
}
  from "vue-property-decorator";
import Datepicker from 'vuejs-datepicker';
export default {
  name: "SummaryContent",
  components: {
    Datepicker,
  },
  data() {
    return {
      filterApplied: false,
      filterValue: {},
      consignment_num: "All",
      purchase_order: "All",
      commodity: "All",
      variety: "All",
      inspection_type: "All",
      grower: "All",
      alert: "All",
      inspector: '',
      approval_status: "All",
      inspecton_date: "",
      inspection_time: "",
      StartDate: "",
      EndDate: "",
      currentSort: 'inspection_date',
      currentSortDir: 'asc',
      submitDisabled: false,
      dtble: {}
    };
  },
  computed: {
    // sorted() {
    //   {console.log("I am in sorting of inspection_summary in Js file")}
    //   this.$store.dispatch('SortInspectionSummary',{'name': this.currentSort, 'sortby': this.currentSortDir })
    // },
    user() {

      return this.$store.state.user
    },
    userName() {
      return this.$store.state.username
    },
    documents() {
      return this.$store.state.documentsInView;
    },
    summary() {
      return this.$store.state.documents;
    },
    consignment_nums() {
      return this.$store.state.consignmentNums
    },
    purchase_orders() {
      return this.consignment_num ==='All'? this.$store.state.purchase_orders:this.$store.state.visible_purchase_orders
    },
    commodities() {
      return this.$store.state.commodities;
    },
    varieties() {
      return this.$store.state.varieties
    },
    inspectionTypes() {
      return this.$store.state.inspectionTypes
    },
    alerts() {
      return ['Passed', 'Failed', 'Border']
    },
    growers() {
      return this.$store.state.growers
    },
    inspectors() {
      return this.$store.state.inspectors
    },
    template() {
      if (this.$store.state.sampleInfo) {
        return "sample";
      } else if (this.$store.state.template) {
        return "info";
      } else if (this.$store.state.report) {
        return "report";
      } else {
        return "summary";
      }
    },
    num_samples() {
      return this.$store.state.num_samples;
    },
    // StartDate(){
    //   var x= new Date(this.$store.state.InspSummFirstDate)
    //   return(x.getFullYear()+"-"+(x.getMonth()+1)>9?(x.getMonth()+1):"0"+(x.getMonth()+1)+"-"+x.getDate())
    // },
    // EndDate(){
    //   return this.$store.state.InspSummLastDate.toDateString()
    // }
  },
  watch: {
    documents(newVal, oldVal) {
      this.refreshTableData()

    }
  },
  methods: {
    formattedDate(datestring) {
      var tempDate = new Date(datestring);
      var tempString = tempDate.toISOString().slice(0, 10);
      var formatted = '';
      formatted += tempString.slice(5, 7) + '-';
      formatted += tempString.slice(8, 10) + '-';
      formatted += tempString.slice(0, 4);
      return formatted;
    },
    sort: function (s) {
      //if s == current sort, reverse
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
      const data = {
        'name': this.currentSort,
        'sortby': this.currentSortDir
      }
      this.$store.dispatch('SortInspectionSummary', data)
    },
    isEditable(dt) {
      if (this.user == 'inspector') return false
      var new_date = dt;
      var month = new_date.slice(0, 2);
      var day = new_date.slice(3, 5);
      var year = new_date.slice(6);
      var dtDate = new Date(year + "-" + month + "-" + day);
      var d = new Date();
      d.setDate(d.getDate() - 10);
      return dtDate > d
    },
    EditReport(id) {
      this.$store.dispatch("updateDocId", id).then(async () => {
        // this.$store.dispatch("getReportsData").then(async() => {
        // this.$store.dispatch("showTemplate");
        await this.$store.dispatch("showNonEditableSamples", true);
        this.$router.push(`/app/secure/inspectionSummary/edit/generalInfo/potato/${id}`)
        // this.$router.go()
        // });
      });
    },
    openReports(commodity, id) {

      this.$store.dispatch("updateDocId", id).then(async () => {
        var logData = {
          user: this.$store.state.username,
          collection: "inspectionReport",
          mode: "view",
          record: id,
          fields: [],
          newValue: [],
          oldValue: []
        }
        await this.$store.dispatch("AddUserLog", logData);

        //  this.$router.push(`/app/secure/inspectionSummary/report/${commodity.toLowerCase()}/${id}`);
        // this.$router.go()
        window.open(`/app/secure/inspectionSummary/report/${commodity.toLowerCase()}/${id}`,'popUpWindow')

        // });
        // });
      });
    },
    CommodityChanged(e) {
      this.variety = "All"
      this.varieties
    },
    async applyFilter() {
      this.filterApplied = true;
      this.filterValue = {
        'consignment_num': this.consignment_num,
        'purchase_order': this.purchase_order,
        'commodity': this.commodity,
        'grower': this.grower,
        'variety': this.variety,
        'inspection_type': this.inspection_type,
        'inspector_name': this.inspector,
        'start_date': this.formattedDate(this.StartDate),
        'end_date': this.formattedDate(this.EndDate),
        'approval_status': this.approval_status == 'All' ? 'All' : JSON.parse(this.approval_status),
        'report_status': this.alert,
      }
      // console.log(this.filterValue);

      /*var docs = [];
      var _documents = this.summary;
      var _filterValue = this.filterValue;
      var count=0;*/
      if (this.filterApplied) {
        var filters = {};
        for (var key in this.filterValue) {
          if (this.filterValue.hasOwnProperty(key) && this.filterValue[key] != 'All') {
            filters[key] = this.filterValue[key];
          }
        }
        await this.$store.dispatch('getDocuments', filters);
        this.currentSort = 'inpection_date';
        this.currentSortDir = 'asc';
        this.sort('inspection_date')

      } else {
        await this.$store.dispatch('getDocuments', filters);
        this.currentSort = 'inpection_date';
        this.currentSortDir = 'asc';
        this.sort('inspection_date')
      }
      //await this.$store.dispatch("applyDateFilter",{sDate:this.StartDate,lDate:this.EndDate});
    },
    changeFilterValue(e) {
      this[e.target.name] = e.target.value;
      if(e.target.name ==='consignment_num' && e.target.value!=='All'){
        this.$store.dispatch('getPONoFromConsignment',e.target.value).then(()=>{
          this.purchase_order = this.purchase_orders[0]
        })
      }
    },
    installDataTable() {
      if(!$("#dataTable1").length) return
      var vm = this
      // console.log(JSON.stringify(this.documents));
      // var data = _.cloneDeep(this.documents)
      $(function () {
        vm.dtble = $("#dataTable1").DataTable({
          order: [],
          data: vm.documents,
          columns: [{
            "data": "report_status",
          },
          {
            "data": "commodity"
          },
          {
            "data": "variety"
          },
          {
            "data": "consignment_num"
          },
          {
            "data": "purchase_order"
          },
          {
            "data": "inspection_type"
          },
          {
            "data": "grower",
          },
          {
            "data": "inspection_time",
            "type": 'datetime',
            "render": (input, type, row) => (new Date(input)).toLocaleDateString()
          },
          {
            "data": "approval_status",
          },
          {
            "data": "reportId",
            orderable: false
          },
          ],
          columnDefs: [{
            targets: 0,
            createdCell: function (td, cellData, rowData, row, col) {
              if (cellData == 'Failed') {
                $(td).html("<span class = \"failed\" > Failed </span>")
              } else if (cellData == 'Passed') {
                $(td).html("<span class = \"passed\" > Passed </span>")
              } else {
                $(td).html("<span class = \"borderline\" > Borderline </span>")
              }
            }
          },
          {
            targets: -1,
            createdCell: function (td, cellData, rowData, row, col) {
              var button = document.createElement("button");
              button.innerHTML = "<div class = \"view\"" +
                "style = \"width:20px;\" ></div>";
              button.className = "view functions func - btn"
              button.onclick = () => vm.openReports(rowData.commodity, cellData)
              $(td).html("")
              $(td).append(button)
            }
          },
          {
            targets: -2,
            createdCell: function (td, cellData, rowData, row, col) {
              if (cellData) {
                $(td).html("<span class=\"approve-image\"></span>" +
                  "<span class = \"appro\" >Approved </span> </td>")
              } else {
                $(td).html("<span class=\"pending-image\"></span>" +
                  "<span class = \"pend\" >Pending </span> </td>")
              }
            }
          },
          {
            targets: 6,
            createdCell: function (td, cellData, rowData, row, col) {
              $(td).html("<span title=\"" + cellData + "\">" + cellData.slice(0, 15) + "</span>")

            }
          }
          ],

        });
        vm.dtble.reload()
      })
    },
    refreshTableData: function () {
      this.dtble.clear();
      this.dtble.rows.add(this.documents).draw();
    }
  },
  async mounted() {
    this.$store.dispatch('showLoader', true)
    var d = new Date()
    this.EndDate = (d.getFullYear() + '-' + ((d.getMonth() + 1) > 9 ? (d.getMonth() + 1) : ('0' + (d.getMonth() + 1))) + '-' + ((d.getDate()) > 9 ? (d.getDate()) : ('0' + d.getDate())));
    d.setDate(d.getDate() - 10)
    this.StartDate = (d.getFullYear() + '-' + ((d.getMonth() + 1) > 9 ? (d.getMonth() + 1) : ('0' + (d.getMonth() + 1))) + '-' + ((d.getDate()) > 9 ? (d.getDate()) : ('0' + d.getDate())));
    this.inspector = this.user == 'inspector' ? this.$store.state.username : "All"
    this.filterValue = {
      'consignment_num': this.consignment_num,
      'purchase_order': this.purchase_order,
      'commodity': this.commodity,
      'grower': this.grower,
      'variety': this.variety,
      'inspection_type': this.inspection_type,
      'inspector_name': this.inspector,
      'start_date': this.formattedDate(this.StartDate),
      'end_date': this.formattedDate(this.EndDate),
      'approval_status': this.approval_status == 'All' ? 'All' : JSON.parse(this.approval_status),
      'report_status': this.alert,
    }

    // this.StartDate.setDate(this.StartDate.getDate()-10)
    var filters = {};
    for (var key in this.filterValue) {
      if (this.filterValue.hasOwnProperty(key) && this.filterValue[key] != 'All') {
        filters[key] = this.filterValue[key];
      }
    }
    await this.$store.dispatch("applyDateFilter", {
      sDate: this.StartDate,
      lDate: this.EndDate
    });
    await this.$store.dispatch("resetState", true);
    await this.$store.dispatch("getDocuments", filters);
    this.currentSort = 'inpection_date';
    this.currentSortDir = 'asc';
    this.sort('inspection_date')
    this.installDataTable()
    this.$store.dispatch('showLoader', false)
  },
  created() {
    this.$store.commit('changePathLabel', {
      view: 'Inspection Summary',
      categories: [],
    });
  }
};